import React from "react";
import { Link } from "react-router-dom";

interface BrandLogoProps {
  className?: string;
  linkTo?: string;
}

/**
 * Responsive brand logo with three display modes:
 * - xs (< 640px): Icon only (package/cube icon)
 * - sm (640-767px): Short text "Inventory"
 * - md+ (768px+): Full text "Inventory Management"
 */
const BrandLogo: React.FC<BrandLogoProps> = ({ className = "", linkTo = "/inventory/metrics" }) => {
  const logoContent = (
    <>
      {/* Icon only on xs screens (< 640px) */}
      <span className="sm:hidden flex items-center justify-center w-10 h-10 bg-blue-600 dark:bg-blue-500 rounded-lg">
        <svg className="w-6 h-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
          />
        </svg>
      </span>
      {/* Short text on sm screens (640-767px) */}
      <h1 className="hidden sm:block md:hidden text-lg font-bold text-gray-900 dark:text-white">
        Inventory
      </h1>
      {/* Full text on md+ screens (768px+) */}
      <h1 className="hidden md:block text-xl font-bold text-gray-900 dark:text-white">
        Inventory Management
      </h1>
    </>
  );

  return (
    <div className={`flex-shrink-0 ${className}`}>
      <Link to={linkTo} className="flex items-center">
        {logoContent}
      </Link>
    </div>
  );
};

export default BrandLogo;
